import { qaBackendApiInstance } from '../config/config'
import { useQuery } from 'react-query'

export const useGetProject = (projectID?: string, domainID?: string) => {
  return useQuery(
    ['useGetProject', projectID, domainID],
    async () => {
      const assets = await qaBackendApiInstance
        .get(`/smp/${projectID}?domain_id=${encodeURIComponent(domainID!)}`)
        .catch((error) => { throw error })
      return assets?.data
    },
    // Don't fire until BOTH projectID and domainID are available.
    // domainID comes from useGetDomainDetails in App.tsx — passing it here
    // means this query is automatically blocked until the domain API resolves.
    { enabled: !!projectID && !!domainID, retry: false }
  )
}
